(function(){
  if (window.__jbHome) return;
  window.__jbHome = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function pad(n){ return (n < 10 ? '0' : '') + n; }
  function initCarousel(c){
    if (c.__jb) return; c.__jb = true;
    var track = c.querySelector('[data-jb-track]');
    if (!track) return;
    var slides = [].slice.call(c.querySelectorAll('[data-jb-slide]'));
    var dots = [].slice.call(c.querySelectorAll('[data-jb-dot]'));
    var count = c.querySelector('[data-jb-count]');
    var idx = 0, timer = null, stopped = false;
    var sec = parseInt(c.getAttribute('data-autoplay') || '0', 10) * 1000;
    function set(i){
      idx = i;
      dots.forEach(function(d, k){ d.classList.toggle('is-active', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (count) count.textContent = pad(i + 1);
    }
    function go(i){
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      set(i);
    }
    track.addEventListener('scroll', function(){
      var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
      if (i !== idx) set(i);
    }, { passive: true });
    dots.forEach(function(d, k){ d.addEventListener('click', function(){ stopped = true; go(k); }); });
    ['pointerdown','touchstart','focusin','mouseenter'].forEach(function(ev){ c.addEventListener(ev, function(){ stopped = true; }, { passive: true }); });
    if (sec > 0 && !reduce && slides.length > 1) {
      timer = setInterval(function(){ if (!stopped && !document.hidden) go(idx + 1); }, sec);
    }
    set(0);
  }
  function initScroller(s){
    if (s.__jb) return; s.__jb = true;
    var row = s.querySelector('[data-jb-scroll]');
    if (!row) return;
    var prev = s.querySelector('[data-jb-prev]');
    var next = s.querySelector('[data-jb-next]');
    function upd(){
      var max = row.scrollWidth - row.clientWidth;
      var fits = max <= 2;
      if (prev) { prev.hidden = fits; prev.disabled = row.scrollLeft <= 2; }
      if (next) { next.hidden = fits; next.disabled = row.scrollLeft >= max - 2; }
    }
    [prev, next].forEach(function(b){
      if (!b) return;
      b.addEventListener('click', function(){
        var dir = b.hasAttribute('data-jb-next') ? 1 : -1;
        row.scrollBy({ left: dir * row.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
    row.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
    setTimeout(upd, 500);
    window.addEventListener('load', upd);
  }
  function init(){
    [].forEach.call(document.querySelectorAll('[data-jb-carousel]'), initCarousel);
    [].forEach.call(document.querySelectorAll('[data-jb-scroller]'), initScroller);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();